
import LocationBennesAveyronSEO from "@/pages/nos-services/location-bennes/LocationBennesAveyronSEO";
import LocationBennesHauteGaronneSEO from "@/pages/nos-services/location-bennes/LocationBennesHauteGaronneSEO";
import LocationBennesTarnSEO from "@/pages/nos-services/location-bennes/LocationBennesTarnSEO";
import LocationBennesLotSEO from "@/pages/nos-services/location-bennes/LocationBennesLotSEO";
import LocationBennesLozereSEO from "@/pages/nos-services/location-bennes/LocationBennesLozereSEO";
import LocationBennesHeraultSEO from "@/pages/nos-services/location-bennes/LocationBennesHeraultSEO";
import LocationBennesTarnEtGaronneSEO from "@/pages/nos-services/location-bennes/LocationBennesTarnEtGaronneSEO";
import LocationBennesValDOiseSEO from "@/pages/nos-services/location-bennes/LocationBennesValDOiseSEO";
import LocationBennesCantalSEO from "@/pages/nos-services/location-bennes/LocationBennesCantalSEO";
import LocationBennesPuyDeDomeSEO from "@/pages/nos-services/location-bennes/LocationBennesPuyDeDomeSEO";

// Import des pages métaux
import AchatMetauxFigeac from "@/pages/nos-services/achat-metaux/AchatMetauxFigeac";
import AchatMetauxMillau from "@/pages/nos-services/achat-metaux/AchatMetauxMillau";
import AchatMetauxDecazeville from "@/pages/nos-services/achat-metaux/AchatMetauxDecazeville";
import AchatMetauxCastres from "@/pages/nos-services/achat-metaux/AchatMetauxCastres";
import AchatMetauxBeauchamp from "@/pages/nos-services/achat-metaux/AchatMetauxBeauchamp";
import AchatMetauxRodez from "@/pages/nos-services/achat-metaux/AchatMetauxRodez";
import AchatMetauxAlbi from "@/pages/nos-services/achat-metaux/AchatMetauxAlbi";
import AchatMetauxAurillac from "@/pages/nos-services/achat-metaux/AchatMetauxAurillac";
import AchatMetauxClermontFerrand from "@/pages/nos-services/achat-metaux/AchatMetauxClermontFerrand";
import AchatMetauxMontpellier from "@/pages/nos-services/achat-metaux/AchatMetauxMontpellier";
import AchatMetauxToulouse from "@/pages/nos-services/achat-metaux/AchatMetauxToulouse";
import AchatMetauxMazamet from "@/pages/nos-services/achat-metaux/AchatMetauxMazamet";
import AchatMetauxCastelnaudary from "@/pages/nos-services/achat-metaux/AchatMetauxCastelnaudary";
import AchatMetauxCarmaux from "@/pages/nos-services/achat-metaux/AchatMetauxCarmaux";

// Import de la page Lozère manquante
import AchatMetauxLozere from "@/pages/nos-services/achat-metaux/AchatMetauxLozere";

// Import des pages départementales manquantes
import AchatMetauxValDOise from "@/pages/nos-services/achat-metaux/AchatMetauxValDOise";
import AchatMetauxHauteGaronne from "@/pages/nos-services/achat-metaux/AchatMetauxHauteGaronne";
import AchatMetauxTarnEtGaronne from "@/pages/nos-services/achat-metaux/AchatMetauxTarnEtGaronne";

// SEO optimized routes
export const seoLocationRoutes = [
  { path: "/nos-services/location-bennes/12", element: LocationBennesAveyronSEO },
  { path: "/nos-services/location-bennes/31", element: LocationBennesHauteGaronneSEO },
  { path: "/nos-services/location-bennes/81", element: LocationBennesTarnSEO },
  { path: "/nos-services/location-bennes/46", element: LocationBennesLotSEO },
  { path: "/nos-services/location-bennes/48", element: LocationBennesLozereSEO },
  { path: "/nos-services/location-bennes/34", element: LocationBennesHeraultSEO },
  { path: "/nos-services/location-bennes/82", element: LocationBennesTarnEtGaronneSEO },
  { path: "/nos-services/location-bennes/95", element: LocationBennesValDOiseSEO },
  { path: "/nos-services/location-bennes/15", element: LocationBennesCantalSEO },
  { path: "/nos-services/location-bennes/63", element: LocationBennesPuyDeDomeSEO },
];

// Alternative SEO routes with keywords
export const seoKeywordRoutes = [
  { path: "/location-bennes-aveyron", element: LocationBennesAveyronSEO },
  { path: "/location-bennes-toulouse", element: LocationBennesHauteGaronneSEO },
  { path: "/location-bennes-tarn", element: LocationBennesTarnSEO },
  { path: "/location-bennes-lot", element: LocationBennesLotSEO },
  { path: "/location-bennes-montpellier", element: LocationBennesHeraultSEO },
  { path: "/location-bennes-cantal", element: LocationBennesCantalSEO },
  { path: "/location-bennes-clermont-ferrand", element: LocationBennesPuyDeDomeSEO },
  { path: "/location-bennes-lozere", element: LocationBennesLozereSEO },
  { path: "/location-bennes-val-doise", element: LocationBennesValDOiseSEO },
];

// Routes SEO pour les pages métaux
export const seoMetauxRoutes = [
  { path: "/nos-services/achat-metaux/figeac", element: AchatMetauxFigeac },
  { path: "/nos-services/achat-metaux/millau", element: AchatMetauxMillau },
  { path: "/nos-services/achat-metaux/decazeville", element: AchatMetauxDecazeville },
  { path: "/nos-services/achat-metaux/castres", element: AchatMetauxCastres },
  { path: "/nos-services/achat-metaux/beauchamp", element: AchatMetauxBeauchamp },
  { path: "/nos-services/achat-metaux/rodez", element: AchatMetauxRodez },
  { path: "/nos-services/achat-metaux/albi", element: AchatMetauxAlbi },
  { path: "/nos-services/achat-metaux/aurillac", element: AchatMetauxAurillac },
  { path: "/nos-services/achat-metaux/clermont-ferrand", element: AchatMetauxClermontFerrand },
  { path: "/nos-services/achat-metaux/montpellier", element: AchatMetauxMontpellier },
  { path: "/nos-services/achat-metaux/toulouse", element: AchatMetauxToulouse },
  { path: "/nos-services/achat-metaux/mazamet", element: AchatMetauxMazamet },
  { path: "/nos-services/achat-metaux/castelnaudary", element: AchatMetauxCastelnaudary },
  { path: "/nos-services/achat-metaux/carmaux", element: AchatMetauxCarmaux },
  { path: "/nos-services/achat-metaux/mende", element: AchatMetauxLozere },
  { path: "/nos-services/achat-metaux/loz-re", element: AchatMetauxLozere },
  // Variantes avec traits d'union
  { path: "/nos-services/achat-metaux/val-d-oise", element: AchatMetauxValDOise },
  { path: "/nos-services/achat-metaux/haute-garonne", element: AchatMetauxHauteGaronne },
  { path: "/nos-services/achat-metaux/tarn-et-garonne", element: AchatMetauxTarnEtGaronne },
];
